import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/J2_Upload.svg'

const J2UploadToCloud: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 30 30'} component={Icon} {...props} fill="currentColor" />
export default J2UploadToCloud
